import theme from 'config/theme';

export default {
  textfield: {
    width: '100%',
    borderRadius: '4px',
    boxShadow: 'none',
    color: theme.palette.grays.gray700,
    // backgroundColor: '#fff',
    '& .MuiInputBase-input': {
      padding: '10px 12px',
      fontSize: '0.85rem',
      width: '100%',
      backgroundColor: '#fff',
      color: theme.palette.grays.gray700,
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: 1,
      borderColor: `${theme.palette.grays.gray300}`,
    },
    '& .Mui-readOnly': {
      backgroundColor: 'transparent',
      pointerEvents: 'none',
      '& .MuiInputBase-input': {
        backgroundColor: 'transparent',
        pointerEvents: 'none',
        color: theme.palette.grays.gray700,
      },
      '.MuiOutlinedInput-notchedOutline': {
        border: 0,
      },
    },
    '& .MuiInputBase-root': {
      fontSize: '0.875rem',
      width: '100%',
      paddingRight: 0,
      '&:hover': {
        backgroundColor: `${theme.palette.grays.lightestGray}`,

        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          color: theme.palette.grays.gray700,
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },

      '&.Mui-focused': {
        backgroundColor: `${theme.palette.grays.lightestGray}`,

        '.MuiOutlinedInput-notchedOutline': {
          border: 1,
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },

      '&.Mui-error': {
        '.MuiOutlinedInput-notchedOutline': {
          boxShadow: `${theme.customShadows.errorShadow}`,
          borderColor: `${theme.palette.reds.codingRed200}`,
        },
        '&.Mui-focused': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
        '&:hover': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },

      '&.Mui-disabled': {
        opacity: 0.8,
        pointerEvents: 'none',

        '& .MuiInputBase-input': {
          backgroundColor: 'transparent',
          pointerEvents: 'none',
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  successTextInput: {
    '& .MuiInputBase-root': {
      fontSize: '0.875rem',
      width: '100%',
      paddingRight: '0',
      '&:hover': {
        backgroundColor: `${theme.palette.grays.lightestGray}`,

        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          color: theme.palette.grays.gray700,
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '& .MuiInputAdornment-positionEnd': {
        display: 'none',
      },
      '&.Mui-focused': {
        paddingRight: '14px',
        '& .MuiInputAdornment-positionEnd': {
          display: 'flex',
        },
        '& .MuiInputBase-input': {
          backgroundColor: '#fff',
        },
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
          boxShadow: '1px 1px 2px 0px rgba(34, 197, 94, 0.30)',
          borderColor: `${theme.palette.greens.codingGreen200}`,
        },
      },
      '&.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          boxShadow: `${theme.customShadows.errorShadow}`,
          borderColor: `${theme.palette.reds.codingRed200}`,
        },
        '&.Mui-focused': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
        '&:hover': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '&.Mui-disabled': {
        opacity: 0.8,
        pointerEvents: 'none',

        '& .MuiInputBase-input': {
          backgroundColor: 'transparent',
          pointerEvents: 'none',
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  warningIcon: {
    color: theme.palette.reds.codingRed400,
    width: '14px',
    marginRight: '12px',
  },
  successIcon: {
    color: theme.palette.greens.codingGreen400,
    width: '14px',
  },
};
